
SessionNewCtrl = ($scope, $filter, $location, flash, AuthService, $cookies) ->
  return $location.path('/') if AuthService.isSignedIn()

  $scope.user =
    email: ''
    password: ''
  $scope.isSubmitting = false
  $scope.locked = false
 
  date = new Date()
  date.setTime(date.getTime() + (300 * 1000)) #5 minutes
  failureAttempts = $cookies.get('loginAttempt')
  if !$cookies.get('loginAttempt')
    failureAttempts = 0

  if failureAttempts >= 5
    flash.error $filter('translate')('_SESSION.NEW.LOCK_ACCOUNT')
    $scope.locked = true

  $scope.submit = (user) ->
    $scope.isSubmitting = true
    AuthService.signIn(user.email, user.password)
      .then ->
        $location.path('/')
      .catch ->
        $scope.isSubmitting = false
        if failureAttempts == 5
          flash.error $filter('translate')('_SESSION.NEW.LOCK_ACCOUNT')
          $scope.check = true
        else
          flash.error $filter('translate')('_SESSION.NEW.ERROR')
          failureAttempts++
          $cookies.put('loginAttempt',failureAttempts,{expires: date})

SessionNewCtrl['$inject'] = [
  '$scope'
  '$filter'
  '$location'
  'flash'
  'AuthService'
  '$cookies'
]

module.exports = SessionNewCtrl





// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/session/new-controller.coffee